import { render, staticRenderFns } from "./RemoveItem.vue?vue&type=template&id=b411b67a&scoped=true&"
import script from "./RemoveItem.vue?vue&type=script&lang=ts&"
export * from "./RemoveItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b411b67a",
  null
  
)

export default component.exports